import React, { Component } from 'react';
import axios from 'axios';
import InputCheckbox from '../form/input/checkbox';

import css from './popup.scss';

export default class FrontpageOnboarding extends Component {
	constructor(props) {
		super();

		this.state = {
			show: false,
			checked: false,
		};
	}

	componentWillMount() {
		axios.get('/api/popup/open').then((res) => {
			if (res.data.show) {
				document.body.classList.add('body--context-menu');
			}
			return this.setState({ ...res.data });
		});
	}

	componentWillUnmount() {
		document.body.classList.remove('body--context-menu');
	}

	render() {
		let onboardClass = 'popup';
		if (this.state.show) {
			onboardClass += ' popup--active';
			// document.body.classList.add('body--context-menu');
		} else {
			document.body.classList.remove('body--context-menu');
			return null;
		}

		return (
			<div className={onboardClass} onClick={(e) => { this.toggle(this.state.show); }}>
				<div className='popup__content span10' onClick={(e) => { e.stopPropagation(); }}>
					<a
						className='popup__content__close'
						onClick={(e) => {
							e.preventDefault();
							this.toggle(this.state.show);
						}}
					>
						{''}
					</a>
					<div className="popup__content__checkbox__wrapper">
						<InputCheckbox name='closepopup' label='Hide this notice' onChange={this.toggleCheckBox}>
							Hide this notice
						</InputCheckbox>
					</div>
					<div className='popup__content__controls'>
					</div>
					<div className='popup__frontpage__wrapper'>
						<h3 className='popup__content__title'>{this.state.title}</h3>
						{this.state.body && (
							<p className='popup__content__text' dangerouslySetInnerHTML={{ __html: this.state.body }}></p>
						)}
						{this.state.link && (
							<div
								onClick={this.handleLinkClick}
								className="timeline-hero__meta-more__button button--go button--dark button popup__button"
								dangerouslySetInnerHTML={{ __html: this.state.link }}
							/>
						)}
					</div>
				</div>
			</div>
		);
	}

	handleLinkClick = (e) => {
		// if click on the DIV (not A!)
		if (e.target.classList.contains('timeline-hero__meta-more__button')) {
			// find the anchor, and click it
			e.target.querySelector('a').click();
			this.toggle(this.state.show);
		} else {
			this.toggle(this.state.show);
		}
	}

	toggleCheckBox = () => {
		this.setState({ checked: !this.state.checked });
	}

	toggle() {
		const { checked } = this.state;
		const formData = new FormData();
		formData.append('closepopup', +checked);
		axios.post('/api/popup/close', formData).catch((err) => {
			alert('something went wrong, check your internet connection');
		});
		const { show } = this.state;
		this.setState({
			show: !show,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/frontpageonboard/index.js
 **/